export interface UserPreference {
  name: string;
  value: string;
  id: string;
  userId: string;
}

export enum LoginType {
  Google = 'Google',
  Email = 'Email',
  Unknown = 'Unknown',
}
export interface UserStatistics {
  averageRating: number;
}

export interface User {
  profile: {
    firstName: string;
    lastName: string;
    avatar: string;
    speaks: string[]; // ids of the language reference
  };
  preferences: UserPreference[];
  role: UserRole;
  email: string;
  createdAt: string;
  updatedAt: string;
  _v: number;
  id: string;
  _id: string;
  password?: string; // Used during registration
  reviews: string[];
  ratings?: { key: string; value: number }[];
  statistics?: UserStatistics;
  loginType: LoginType;
  status: UserStatus;
}

export enum UserStatus {
  PendingActivation = 'PendingActivation',
  Active = 'Active',
  Disabled = 'Disabled',
  Deleted = 'Deleted',
}

export enum UserRole {
  Admin = 'Admin',
  User = 'User',
}

export function createUser(params: Partial<User>) {
  return {} as User;
}
